import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { mapDispatchToProps, mapStateToProps } from '../../reducers/_dispatchers';
import Discover from '../Discover/Discover';
import Error404 from '../404/404';
import Play from '../Play/Play';
import PrizesList from '../PrizesList/PrizesList';
import PrizeWinned from '../PrizeWinned/PrizeWinned';
import Welcome from '../Welcome/Welcome';

class App extends Component {
    componentWillMount() {
        // Quitar comentario
        this.props.resetPrize(null);
    }

    render() {
        return (
            <section className="section-body">
                <Router>
                    <Switch>
                        <Route exact path="/" component={Welcome}/>
                        <Route exact path="/discover" component={Discover} />
                        <Route exact path="/play" component={Play} />
                        <Route exact path="/prize-list" component={PrizesList} />
                        <Route exact path="/prize-winned/" component={PrizeWinned} />
                        <Route exact path="/prize-winned/recipe/:recetaID?" component={PrizeWinned} />
                        <Route exact path="/prize-winned/postal/:postalID?" component={PrizeWinned} />
                        <Route component={Error404}/>
                    </Switch>
                </Router>
            </section>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
